import axios from 'axios'

export default {
  refreshCart: params => axios.get('/api/cart/v2/refresh', { params }),

  getUserPaymentMethods: () => axios.get(`/api/payment/v2/methods`),
  deleteUserCreditCard: token => axios.delete(`/api/payment/v2/credit-cards/${token}`),
  deleteUserDebitAccount: token => axios.delete(`/api/payment/v2/debit-accounts/${token}`),

  addDiscount: data => axios.post(`/api/cart/v2/discount/add`, data),
  removeDiscount: data => axios.post(`/api/cart/v2/discount/remove`, data),

  checkout: data => axios.post(`/api/cart/v2/checkout`, data),

  addItemToCart: (productId, params) => axios.get(`/api/cart/v2/add/${productId}`, { params }),
  updateItemQuantity: (productId, data) => axios.post(`/api/cart/v2/update/${productId}`, data),
  removeItemFromCart: (productId, params) => axios.get(`/api/cart/v2/remove/${productId}`, { params }),

  getCurrencies: () => axios.get('/api/cart/v2/currencies'),
  postCurrencyChange: data => axios.post(`/api/cart/v2/currency`, data),

  validateVatTax: data => axios.post(`/api/cart/v2/tax/vat/validate`, data),
  // getVatRate: data => axios.post(`/api/cart/v2/tax/vat/rate`, data),

  postEventQuestions: data => axios.post('/api/cart/v2/event-topics', data),

  login: data => axios.post(`/handleLogin`, data),

  getJobIndustries: () => axios.get(`/api/job-industries`),
  getJobTitles: () => axios.get(`/api/job-classifications`),
  getJobFunctions: () => axios.get(`/api/job-functions`),

  getSavedCCNonce: (token) => axios.get(`/api/cart/v2/vault/${token}`),
  getClientToken: (currency) => axios.get(`/api/cart/v2/client-token?currency=${currency}`),
}

